// PrimeHat's own department menu (the operator approved the draft 2026-11-01, then asked for every sub-category, kids' clothing,
// food and the other popular F-commerce categories). Written from one tree, so it is the same tree as
// deploy/primehat-seed-categories.sql and mobile-menu.ts - keep the three in step by hand. STATIC on purpose: the API fetch in
// departments.component.ts is commented out, so a category appears here only when it is added below AND exists in the
// database (the seed file makes the new ones; it is safe to run twice).
//
// Grouped as a Bangladeshi shopper looks for things: fashion, shoes and bags, jewellery and watches, health and beauty,
// food and grocery, electronics, computers, home appliances, home and kitchen, decor, toys, baby care, car and bike, books,
// Islamic lifestyle. A department is a real category, so its page lists everything under it; a group (Women's Clothing,
// Phone Gadgets...) nests where the database does, except Smart Home under Electronics and Travel Tech under Shoes & Bags,
// which are menu groupings of categories that have roots of their own.
import { NavigationLink } from '../app/shared/interfaces/navigation-link';

export const departments: NavigationLink[] =
[
  {
    "key": "cat-fashion-clothing",
    "label": "Fashion & Clothing",
    "url": "/products/clothing",
    "menu": {
      "type": "menu",
      "items": [
        {
          "key": "cat-women-clothing",
          "label": "Women's Clothing",
          "url": "/products/women-clothing",
          "items": [
            {
              "key": "cat-saree",
              "label": "Saree",
              "url": "/products/saree"
            },
            {
              "key": "cat-three-piece",
              "label": "Three-Piece",
              "url": "/products/three-piece"
            },
            {
              "key": "cat-kurti-and-tops",
              "label": "Kurti & Tops",
              "url": "/products/kurti-and-tops"
            },
            {
              "key": "cat-hijab-and-burqa",
              "label": "Hijab & Burqa",
              "url": "/products/hijab-and-burqa"
            },
            {
              "key": "cat-women-western-wear",
              "label": "Western Wear",
              "url": "/products/women-western-wear"
            },
            {
              "key": "cat-womens-nightwear",
              "label": "Nightwear & Innerwear",
              "url": "/products/womens-nightwear"
            }
          ]
        },
        {
          "key": "cat-men-clothing",
          "label": "Men's Clothing",
          "url": "/products/men-clothing",
          "items": [
            {
              "key": "cat-panjabi",
              "label": "Panjabi & Kabli",
              "url": "/products/panjabi"
            },
            {
              "key": "cat-mens-shirts",
              "label": "Shirts",
              "url": "/products/mens-shirts"
            },
            {
              "key": "cat-mens-tshirts-polo",
              "label": "T-Shirts & Polo",
              "url": "/products/mens-tshirts-polo"
            },
            {
              "key": "cat-mens-pants-jeans",
              "label": "Pants & Jeans",
              "url": "/products/mens-pants-jeans"
            },
            {
              "key": "cat-lungi-and-pajama",
              "label": "Lungi & Pajama",
              "url": "/products/lungi-and-pajama"
            }
          ]
        },
        {
          "key": "cat-kids-clothing",
          "label": "Kids Clothing",
          "url": "/products/kids-clothing",
          "items": [
            {
              "key": "cat-baby-clothing",
              "label": "Baby Clothing",
              "url": "/products/baby-clothing"
            },
            {
              "key": "cat-boys-clothing",
              "label": "Boys' Clothing",
              "url": "/products/boys-clothing"
            },
            {
              "key": "cat-girls-clothing",
              "label": "Girls' Clothing",
              "url": "/products/girls-clothing"
            }
          ]
        },
        {
          "key": "cat-sunglasses-and-eyewear",
          "label": "Sunglasses & Eyewear",
          "url": "/products/sunglasses-and-eyewear"
        }
      ]
    }
  },
  {
    "key": "cat-shoes-and-bags",
    "label": "Shoes & Bags",
    "url": "/products/shoes-and-bags",
    "menu": {
      "type": "menu",
      "items": [
        {
          "key": "cat-mens-shoes",
          "label": "Men's Shoes",
          "url": "/products/mens-shoes"
        },
        {
          "key": "cat-womens-shoes",
          "label": "Women's Shoes",
          "url": "/products/womens-shoes"
        },
        {
          "key": "cat-kids-shoes",
          "label": "Kids' Shoes",
          "url": "/products/kids-shoes"
        },
        {
          "key": "cat-sandals-and-slippers",
          "label": "Sandals & Slippers",
          "url": "/products/sandals-and-slippers"
        },
        {
          "key": "cat-bags-and-backpacks",
          "label": "Bags & Backpacks",
          "url": "/products/bags-and-backpacks"
        },
        {
          "key": "cat-wallets-and-cardholders",
          "label": "Wallets & Cardholders",
          "url": "/products/wallets-and-cardholders"
        },
        {
          "key": "cat-travel-tech",
          "label": "Travel Tech",
          "url": "/products/travel-tech"
        }
      ]
    }
  },
  {
    "key": "cat-jewellery-and-watches",
    "label": "Jewellery And Watches",
    "url": "/products/jewellery-and-watches",
    "menu": {
      "type": "menu",
      "items": [
        {
          "key": "cat-watches",
          "label": "Watches",
          "url": "/products/watches"
        },
        {
          "key": "cat-smart-watches",
          "label": "Smart Watches",
          "url": "/products/smart-watch"
        },
        {
          "key": "cat-jewellery-and-style",
          "label": "Jewellery And Style",
          "url": "/products/jewellery",
          "items": [
            {
              "key": "cat-necklaces-and-pendants",
              "label": "Necklaces & Pendants",
              "url": "/products/necklaces-and-pendants"
            },
            {
              "key": "cat-earrings",
              "label": "Earrings",
              "url": "/products/earrings"
            },
            {
              "key": "cat-rings",
              "label": "Rings",
              "url": "/products/rings"
            },
            {
              "key": "cat-bangles-and-bracelets",
              "label": "Bangles & Bracelets",
              "url": "/products/bangles-and-bracelets"
            }
          ]
        }
      ]
    }
  },
  {
    "key": "cat-health-and-beauty",
    "label": "Health & Beauty",
    "url": "/products/health-and-life",
    "menu": {
      "type": "menu",
      "items": [
        {
          "key": "cat-skin-care",
          "label": "Skin Care",
          "url": "/products/skin-care"
        },
        {
          "key": "cat-hair-care",
          "label": "Hair Care",
          "url": "/products/hair-style"
        },
        {
          "key": "cat-makeup",
          "label": "Makeup",
          "url": "/products/makeup"
        },
        {
          "key": "cat-perfume-and-attar",
          "label": "Perfume & Attar",
          "url": "/products/perfume-and-attar"
        },
        {
          "key": "cat-beauty-devices",
          "label": "Beauty Devices",
          "url": "/products/beauty-devices"
        },
        {
          "key": "cat-grooming-trimmers",
          "label": "Grooming & Trimmers",
          "url": "/products/grooming-and-trimmers"
        },
        {
          "key": "cat-fitness-recovery",
          "label": "Fitness & Recovery",
          "url": "/products/fitness-and-recovery",
          "items": [
            {
              "key": "cat-massage-recovery",
              "label": "Massage & Recovery",
              "url": "/products/massage-and-recovery"
            },
            {
              "key": "cat-gym-accessories",
              "label": "Gym Accessories",
              "url": "/products/gym-accessories"
            },
            {
              "key": "cat-posture-support",
              "label": "Posture & Support",
              "url": "/products/posture-and-support"
            }
          ]
        }
      ]
    }
  },
  {
    "key": "cat-food-and-grocery",
    "label": "Food & Grocery",
    "url": "/products/food-and-grocery",
    "menu": {
      "type": "menu",
      "items": [
        {
          "key": "cat-honey",
          "label": "Honey",
          "url": "/products/honey"
        },
        {
          "key": "cat-dates-and-dry-fruits",
          "label": "Dates & Dry Fruits",
          "url": "/products/dates-and-dry-fruits"
        },
        {
          "key": "cat-nuts-and-seeds",
          "label": "Nuts & Seeds",
          "url": "/products/nuts-and-seeds"
        },
        {
          "key": "cat-snacks-and-biscuits",
          "label": "Snacks & Biscuits",
          "url": "/products/snacks-and-biscuits"
        },
        {
          "key": "cat-sweets-and-mishti",
          "label": "Sweets & Mishti",
          "url": "/products/sweets-and-mishti"
        },
        {
          "key": "cat-spices-and-masala",
          "label": "Spices & Masala",
          "url": "/products/spices-and-masala"
        },
        {
          "key": "cat-oil-and-ghee",
          "label": "Oil & Ghee",
          "url": "/products/oil-and-ghee"
        },
        {
          "key": "cat-tea-and-coffee",
          "label": "Tea & Coffee",
          "url": "/products/tea-and-coffee"
        },
        {
          "key": "cat-pickles-and-sauces",
          "label": "Pickles & Sauces",
          "url": "/products/pickles-and-sauces"
        },
        {
          "key": "cat-rice-pulses-and-flour",
          "label": "Rice, Pulses & Flour",
          "url": "/products/rice-pulses-and-flour"
        }
      ]
    }
  },
  {
    "key": "cat-electronics-gadgets",
    "label": "Electronics & Gadgets",
    "url": "/products/gadget-and-gears",
    "menu": {
      "type": "menu",
      "items": [
        {
          "key": "cat-mobile-phones",
          "label": "Mobile Phones",
          "url": "/products/mobile-phones"
        },
        {
          "key": "cat-phone-gadgets",
          "label": "Phone Gadgets",
          "url": "/products/phone-gadgets",
          "items": [
            {
              "key": "cat-chargers-power-banks",
              "label": "Chargers & Power Banks",
              "url": "/products/chargers-power-banks"
            },
            {
              "key": "cat-phone-stands-holders",
              "label": "Phone Stands & Holders",
              "url": "/products/phone-stands-holders"
            },
            {
              "key": "cat-phone-cases",
              "label": "Phone Cases",
              "url": "/products/phone-cases"
            },
            {
              "key": "cat-magsafe-mounts",
              "label": "MagSafe & Mounts",
              "url": "/products/magsafe-and-mounts"
            }
          ]
        },
        {
          "key": "cat-headphone-earbuds",
          "label": "Headphone & Earbuds",
          "url": "/products/headphones"
        },
        {
          "key": "cat-audio-accessories",
          "label": "Audio Accessories",
          "url": "/products/audio-accessories"
        },
        {
          "key": "cat-tablets",
          "label": "Tablets",
          "url": "/products/tablets"
        },
        {
          "key": "cat-cameras-and-photography",
          "label": "Cameras & Photography",
          "url": "/products/cameras-and-photography"
        },
        {
          "key": "cat-drone-uav",
          "label": "Drone & UAV",
          "url": "/products/drone"
        },
        {
          "key": "cat-vr-and-ar",
          "label": "VR And AR",
          "url": "/products/vr-and-ar"
        },
        {
          "key": "cat-gaming",
          "label": "Gaming",
          "url": "/products/gaming",
          "items": [
            {
              "key": "cat-controllers-accessories",
              "label": "Controllers & Accessories",
              "url": "/products/controller-accessories"
            },
            {
              "key": "cat-console-accessories",
              "label": "Console Accessories",
              "url": "/products/console-accessories"
            },
            {
              "key": "cat-gaming-headsets",
              "label": "Gaming Headsets",
              "url": "/products/gaming-headsets"
            },
            {
              "key": "cat-handheld-consoles",
              "label": "Handheld Consoles",
              "url": "/products/handheld-consoles"
            },
            {
              "key": "cat-gaming-consoles",
              "label": "Gaming Consoles",
              "url": "/products/gaming-consoles"
            },
            {
              "key": "cat-accessories",
              "label": "Accessories",
              "url": "/products/gaming-accessories"
            }
          ]
        },
        {
          "key": "cat-smart-home",
          "label": "Smart Home",
          "url": "/products/smart-home",
          "items": [
            {
              "key": "cat-smart-lighting",
              "label": "Smart Lighting",
              "url": "/products/smart-lighting"
            },
            {
              "key": "cat-smart-plugs-switches",
              "label": "Smart Plugs & Switches",
              "url": "/products/smart-plugs-and-switches"
            },
            {
              "key": "cat-sensors-automation",
              "label": "Sensors & Automation",
              "url": "/products/sensors-and-automation"
            },
            {
              "key": "cat-home-security",
              "label": "Home Security",
              "url": "/products/home-security"
            }
          ]
        }
      ]
    }
  },
  {
    "key": "cat-computers-office",
    "label": "Computers & Office",
    "url": "/products/pc-and-gaming",
    "menu": {
      "type": "menu",
      "items": [
        {
          "key": "cat-laptops-and-computers",
          "label": "Laptops & Computers",
          "url": "/products/laptops-and-computers"
        },
        {
          "key": "cat-monitors-and-storage",
          "label": "Monitors & Storage",
          "url": "/products/monitors-and-storage"
        },
        {
          "key": "cat-accessories",
          "label": "Accessories",
          "url": "/products/pc-accessories",
          "items": [
            {
              "key": "cat-mouse-pads-desk-mats",
              "label": "Mouse Pads & Desk Mats",
              "url": "/products/mouse-pads-desk-mats"
            },
            {
              "key": "cat-keyboards-mice",
              "label": "Keyboards & Mice",
              "url": "/products/keyboards-and-mice"
            },
            {
              "key": "cat-laptop-stands-docks",
              "label": "Laptop Stands & Docks",
              "url": "/products/laptop-stands-docks"
            },
            {
              "key": "cat-usb-hubs-adapters",
              "label": "USB Hubs & Adapters",
              "url": "/products/usb-hubs-adapters"
            }
          ]
        },
        {
          "key": "cat-desk-accessories",
          "label": "Desk Accessories",
          "url": "/products/desk-accessories",
          "items": [
            {
              "key": "cat-desk-lighting-rgb",
              "label": "Desk Lighting & RGB",
              "url": "/products/desk-lighting-rgb"
            },
            {
              "key": "cat-cable-management",
              "label": "Cable Management",
              "url": "/products/cable-management"
            }
          ]
        }
      ]
    }
  },
  {
    "key": "cat-home-appliances",
    "label": "Home Appliances",
    "url": "/products/home-appliances",
    "menu": {
      "type": "menu",
      "items": [
        {
          "key": "cat-kitchen-appliances",
          "label": "Kitchen Appliances",
          "url": "/products/kitchen-appliances"
        },
        {
          "key": "cat-fans-coolers-heaters",
          "label": "Fans, Coolers & Heaters",
          "url": "/products/fans-coolers-heaters"
        },
        {
          "key": "cat-irons-and-garment-care",
          "label": "Irons & Garment Care",
          "url": "/products/irons-and-garment-care"
        },
        {
          "key": "cat-lighting-and-electricals",
          "label": "Lighting & Electricals",
          "url": "/products/lighting-and-electricals"
        }
      ]
    }
  },
  {
    "key": "cat-home-and-kitchen",
    "label": "Home & Kitchen",
    "url": "/products/home-and-kitchen",
    "menu": {
      "type": "menu",
      "items": [
        {
          "key": "cat-kitchen-gadgets",
          "label": "Kitchen Gadgets",
          "url": "/products/kitchen-gadgets"
        },
        {
          "key": "cat-cookware-and-dinnerware",
          "label": "Cookware & Dinnerware",
          "url": "/products/cookware-and-dinnerware"
        },
        {
          "key": "cat-cleaning-gadgets",
          "label": "Cleaning Gadgets",
          "url": "/products/cleaning-gadgets"
        },
        {
          "key": "cat-storage-and-organisers",
          "label": "Storage & Organisers",
          "url": "/products/storage-and-organisers"
        },
        {
          "key": "cat-bedding-and-furnishing",
          "label": "Bedding & Furnishing",
          "url": "/products/bedding-and-furnishing",
          "items": [
            {
              "key": "cat-bed-sheets",
              "label": "Bed Sheets",
              "url": "/products/bed-sheets"
            },
            {
              "key": "cat-curtains-and-blinds",
              "label": "Curtains & Blinds",
              "url": "/products/curtains-and-blinds"
            },
            {
              "key": "cat-pillows-and-blankets",
              "label": "Pillows & Blankets",
              "url": "/products/pillows-and-blankets"
            }
          ]
        },
        {
          "key": "cat-furniture",
          "label": "Furniture",
          "url": "/products/furniture"
        }
      ]
    }
  },
  {
    "key": "cat-home-decor",
    "label": "Home Decor",
    "url": "/products/home-decor",
    "menu": {
      "type": "menu",
      "items": [
        {
          "key": "cat-wall-decor",
          "label": "Wall Decor",
          "url": "/products/wall-decor",
          "items": [
            {
              "key": "cat-wall-clock",
              "label": "Wall Clock",
              "url": "/products/wall-clock"
            },
            {
              "key": "cat-wall-hanging-items",
              "label": "Wall Hanging Items",
              "url": "/products/wall-hanging"
            },
            {
              "key": "cat-wall-stickers",
              "label": "Wall Stickers",
              "url": "/products/wall-sticker"
            }
          ]
        },
        {
          "key": "cat-vases-and-plants",
          "label": "Vases & Artificial Plants",
          "url": "/products/vases-and-plants"
        },
        {
          "key": "cat-showpieces-and-gifts",
          "label": "Showpieces & Gifts",
          "url": "/products/showpieces-and-gifts"
        }
      ]
    }
  },
  {
    "key": "cat-toys",
    "label": "Toys",
    "url": "/products/toys",
    "menu": {
      "type": "menu",
      "items": [
        {
          "key": "cat-learning-toys",
          "label": "Learning Toys",
          "url": "/products/learning-toys"
        },
        {
          "key": "cat-soft-toys",
          "label": "Soft Toys",
          "url": "/products/soft-toys"
        },
        {
          "key": "cat-remote-control-toys",
          "label": "Remote Control Toys",
          "url": "/products/remote-control-toys"
        },
        {
          "key": "cat-car-models",
          "label": "Car Models",
          "url": "/products/car-models"
        }
      ]
    }
  },
  {
    "key": "cat-baby-care",
    "label": "Baby Care",
    "url": "/products/baby-care",
    "menu": {
      "type": "menu",
      "items": [
        {
          "key": "cat-diapers-and-wipes",
          "label": "Diapers & Wipes",
          "url": "/products/diapers-and-wipes"
        },
        {
          "key": "cat-baby-feeding",
          "label": "Baby Feeding",
          "url": "/products/baby-feeding"
        },
        {
          "key": "cat-baby-bath-and-skincare",
          "label": "Baby Bath & Skincare",
          "url": "/products/baby-bath-and-skincare"
        },
        {
          "key": "cat-baby-gear",
          "label": "Baby Gear & Strollers",
          "url": "/products/baby-gear"
        }
      ]
    }
  },
  {
    "key": "cat-car-bike",
    "label": "Car & Bike",
    "url": "/products/car-and-bike",
    "menu": {
      "type": "menu",
      "items": [
        {
          "key": "cat-car-ambient-lighting",
          "label": "Car Ambient Lighting",
          "url": "/products/car-lighting"
        },
        {
          "key": "cat-car-organisers-storage",
          "label": "Car Organisers & Storage",
          "url": "/products/car-organisers"
        },
        {
          "key": "cat-car-decor-accessories",
          "label": "Car Decor & Accessories",
          "url": "/products/car-accessories"
        },
        {
          "key": "cat-car-electronics-dash-cams",
          "label": "Car Electronics & Dash Cams",
          "url": "/products/car-electronics"
        },
        {
          "key": "cat-tyre-car-care-tools",
          "label": "Tyre & Car Care Tools",
          "url": "/products/car-care-tools"
        },
        {
          "key": "cat-car-air-freshener",
          "label": "Car Air Freshener",
          "url": "/products/car-air-freshener"
        },
        {
          "key": "cat-bike-accessories",
          "label": "Bike Accessories",
          "url": "/products/bike-accessories"
        }
      ]
    }
  },
  {
    "key": "cat-books-and-stationery",
    "label": "Books & Stationery",
    "url": "/products/books-and-stationery",
    "menu": {
      "type": "menu",
      "items": [
        {
          "key": "cat-books",
          "label": "Books",
          "url": "/products/books"
        },
        {
          "key": "cat-stationery",
          "label": "Stationery",
          "url": "/products/stationery"
        },
        {
          "key": "cat-art-and-craft",
          "label": "Art & Craft",
          "url": "/products/art-and-craft"
        },
        {
          "key": "cat-school-supplies",
          "label": "School Supplies",
          "url": "/products/school-supplies"
        }
      ]
    }
  },
  {
    "key": "cat-islamic-lifestyle",
    "label": "Islamic Lifestyle",
    "url": "/products/islamic-lifestyle",
    "menu": {
      "type": "menu",
      "items": [
        {
          "key": "cat-prayer-mats",
          "label": "Prayer Mats",
          "url": "/products/prayer-mats"
        },
        {
          "key": "cat-tasbih-and-beads",
          "label": "Tasbih & Beads",
          "url": "/products/tasbih-and-beads"
        },
        {
          "key": "cat-islamic-decor",
          "label": "Islamic Decor",
          "url": "/products/islamic-decor"
        }
      ]
    }
  }
];
